import {
    Component,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { Router } from '@angular/router';
import { ProviderContext } from '../../data/Entities';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { setTimeout } from 'timers';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Helpers } from '../../services/Helpers';

import { ResourceItemDTO } from '../../data/Entities';

declare var jQuery: any;

@Component({
    selector: 'delivererresource_list',
    templateUrl: '/templates/get/DelivererResource/delivererresource_list',
})
export class DelivererResourceList implements OnInit {
    public current_row: any;

    public dtx: ProviderContext;
    public rows: any = [];
    fromDate: Date;
    toDate: Date;
    dayDateFrom: Date;
    dayDateTo: Date;
    public modalRef: BsModalRef;
    dateplus: boolean;
    hours: Array<any> = [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
    ];

    entityList: Array<ResourceItemDTO> = [];

    pcode = 'DELIVERERRESOURCE';

    @ViewChild('resourcetemplate')
    private resourceTemplateRef: TemplateRef<any>;

    constructor(
        public siteServices: SiteServices,
        private modalService: BsModalService,
        public viewRef: ViewContainerRef,
        private router: Router,
        private http: HttpClient
    ) {
        this.dtx = new ProviderContext({
            ProviderCode: this.pcode,
        });
        this.initModel();
    }

    public ngOnInit() {
        this.fromDate = new Date();
        this.toDate = new Date();
        this.dayDateFrom = new Date();
        this.dayDateTo = new Date();
        this.toDate.setDate(this.toDate.getDate() + 7);
        this.refresh();
    }

    public refresh() {
        this.rows = [];

        this.dtx.clearFilter();
        this.dtx.addFilter('FromDate', this.fromDate.toISOString());
        this.dtx.addFilter('ToDate', this.toDate.toISOString());

        this.siteServices.provider_GetAll(this.dtx, (data) => {
            this.rows = data.TagObject;
        });
    }

    public add() {
        this.initModel();
        this.modalRef = this.modalService.show(this.resourceTemplateRef, {
            class: 'modal-md',
        });
    }

    initModel() {
        this.entityList.splice(0, this.entityList.length); //clear
        for (var i = 0; i <= 14; i++) {
            this.entityList.push(new ResourceItemDTO());
        }
    }

    delDay(datekey: string) {
        this.siteServices.provider_Execute(
            this.pcode,
            'DELDAY',
            { DateKey: datekey },
            (data) => {
                this.refresh();
            }
        );
    }

    saveList() {
        console.log(this.dayDateFrom, this.dayDateTo);

        this.entityList.forEach((x) => {
            x.DayDateFrom = this.dayDateFrom;
            if (this.dateplus) {
                x.DayDateTo = this.dayDateTo;
            } else x.DayDateTo = null;
        });

        this.siteServices.provider_Execute(
            this.pcode,
            'SAVEITEMLIST',
            this.entityList,
            (data) => {
                this.refresh();
            }
        );
    }
}
